import PropTypes from "prop-types";

import { Badge } from "@/components/ui/badge";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";

const formatIds = ids => `#${ids.join(", #")}`;

/**
 * Marks an entry that was carried over from a merged contact or entity. The
 * tooltip lists the records it came from.
 */
const MergedBadge = ({ mergedFromContacts, mergedFromEntities }) => (
  <Tooltip>
    <TooltipTrigger render={<Badge variant="warning" size="sm" />}>
      Merged
    </TooltipTrigger>
    <TooltipContent>
      <div className="tw:flex tw:flex-col">
        {mergedFromContacts && (
          <span>Merged from contacts: {formatIds(mergedFromContacts)}</span>
        )}
        {mergedFromEntities && (
          <span>Merged from entities: {formatIds(mergedFromEntities)}</span>
        )}
      </div>
    </TooltipContent>
  </Tooltip>
);

MergedBadge.propTypes = {
  mergedFromContacts: PropTypes.arrayOf(PropTypes.number),
  mergedFromEntities: PropTypes.arrayOf(PropTypes.number),
};

export default MergedBadge;
